<template>
  <div>
    <v-overlay :value="cargandoCreacionSolicitud" z-index="300">
      <div class="d-flex flex-column align-center">
        <v-progress-circular indeterminate size="48"></v-progress-circular>
        <p class="mt-4">Estamos guardando tu firma...</p>
      </div>
    </v-overlay>
    <Toolbar v-if="!esMobile" />
    <div :class="esMobile ? 'landscape-content' : 'desktop-content'">
      <h3 class="firma-titulo">Ingresa tu firma en el recuadro de abajo:</h3>

      <div class="signature-pad">
        <canvas
          ref="canvas"
          :class="[
            'signature-pad-canvas',
            { 'signature-pad-canvas--disabled': cargandoCreacionSolicitud },
          ]"
          @touchstart.prevent="startDrawing"
          @touchmove.prevent="draw"
          @touchend.prevent="stopDrawing"
          @touchcancel.prevent="stopDrawing"
          @mousedown.prevent="startDrawing"
          @mousemove.prevent="draw"
          @mouseup.prevent="stopDrawing"
          @mouseleave.prevent="stopDrawing"
        ></canvas>

        <div class="signature-actions">
          <v-btn
            :disabled="cargandoCreacionSolicitud"
            color="primary"
            @click="clearCanvas"
          >
            Limpiar
          </v-btn>

          <v-btn
            color="primary"
            @click="getSignatureImage"
            :disabled="cargandoCreacionSolicitud || !isAlreadyDrawing"
            :loading="cargandoCreacionSolicitud"
          >
            Firmar y Continuar
          </v-btn>
        </div>
      </div>

      <div
        v-if="$store.getters['credito/obtenerObservacionesDevolucion'] != ''"
        class="observaciones-firma"
      >
        <v-alert
          dense
          text
          type="info"
          :icon="false"
          class="text-center font-weight-black ma-0"
        >
          <p>Observaciones:</p>
          <p>{{ $store.getters['credito/obtenerObservacionesDevolucion'] }}</p>
        </v-alert>
      </div>
    </div>
  </div>
</template>

<script>
import Toolbar from '@/components/compartidos/Toolbar.vue'
import { mapActions, mapGetters } from 'vuex'
import CreditoService from '@/servicios/credito'
import PersonaService from '@/servicios/persona'
import { ALERTA_ERROR } from '@/utilidades/utilidades'
import { GuardaFirmaAutografaDigitalMixin } from '@/mixins/persona/GuardaFirmaAutografaDigital.mixin'
import { ActualizaEstatusSolicitudMixin } from '@/mixins/credito/ActualizaEstatusSolicitud.mixin'

export default {
  components: {
    Toolbar,
  },
  mixins: [GuardaFirmaAutografaDigitalMixin, ActualizaEstatusSolicitudMixin],
  data() {
    return {
      isDrawing: false,
      cargandoCreacionSolicitud: false,
      isAlreadyDrawing: false,
      lastX: 0,
      lastY: 0,
    }
  },
  mounted() {
    this.isAlreadyDrawing = false
    this.$nextTick(() => this.resizeCanvas())
    window.addEventListener('resize', this.resizeCanvas)
    if (screen.orientation && screen.orientation.lock) {
      screen.orientation.lock('landscape').catch(() => {})
    }
  },
  computed: {
    esMobile() {
      return (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
          navigator.userAgent
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw(n|u)|c55\/|capi|ccwa|cdm|cell|chtm|cldc|cmd|co(mp|nd)|craw|da(it|ll|ng)|dbte|dcs|devi|dica|dmob|do(c|p)o|ds(12|d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd(m|p|t)|hei|hi(pt|ta)|hp( i|ip)|hsc|ht(c(| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i(20|go|ma)|i230|iac( ||\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|[a-w])|libw|lynx|m1w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|mcr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|([1-8]|c))|phil|pire|pl(ay|uc)|pn2|po(ck|rt|se)|prox|psio|ptg|qaa|qc(07|12|21|32|60|[2-7]|i)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h|v|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl|tdg|tel(i|m)|tim|tmo|to(pl|sh)|ts(70|m|m3|m5)|tx9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas|your|zeto|zte/i.test(
          navigator.userAgent.substr(0, 4)
        )
      )
    },
    ...mapGetters({
      obtenerOtpFirma: 'credito/obtenerOtpFirma',
      obtenerEsOtpFirmaValido: 'credito/obtenerEsOtpFirmaValido',
      obtenerAceptaFirmar: 'credito/obtenerAceptaFirmar',
      obtenerSonTerminosBuroConfirmados:
        'credito/obtenerSonTerminosBuroConfirmados',
      obtenerCredito: 'credito/obtenerCredito',
    }),
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCanvas)
    if (screen.orientation && screen.orientation.unlock) {
      screen.orientation.unlock()
    }
  },
  methods: {
    postActualizaEstatusSolicitud() {
      this.cargandoCreacionSolicitud = false
      this.$store.dispatch('credito/actualizarConfirmacion', false)
      this.$router.push('terminacionActualizacion')
    },

    setCanvasStyles(ctx) {
      ctx.strokeStyle = '#000'
      ctx.lineWidth = 1.2
      ctx.lineCap = 'round'
      ctx.lineJoin = 'round'
    },

    resizeCanvas() {
      const canvas = this.$refs.canvas
      if (!canvas) return
      if (this.isAlreadyDrawing) return

      const dpr = window.devicePixelRatio || 1

      // En móvil el padre está rotado 90°: getBoundingClientRect devuelve
      // dimensiones visuales (intercambiadas). offsetWidth/offsetHeight
      // devuelven el tamaño real de layout, sin verse afectados por la rotación.
      const logicalW = this.esMobile
        ? canvas.offsetWidth
        : canvas.getBoundingClientRect().width
      const logicalH = this.esMobile
        ? canvas.offsetHeight
        : canvas.getBoundingClientRect().height

      canvas.width = Math.round(logicalW * dpr)
      canvas.height = Math.round(logicalH * dpr)

      const ctx = canvas.getContext('2d')
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
      this.setCanvasStyles(ctx)
    },

    getPoint(e) {
      const canvas = this.$refs.canvas
      const rect = canvas.getBoundingClientRect()

      let clientX = 0
      let clientY = 0

      if (e.touches && e.touches.length > 0) {
        clientX = e.touches[0].clientX
        clientY = e.touches[0].clientY
      } else if (e.changedTouches && e.changedTouches.length > 0) {
        clientX = e.changedTouches[0].clientX
        clientY = e.changedTouches[0].clientY
      } else {
        clientX = e.clientX
        clientY = e.clientY
      }

      if (this.esMobile) {
        // El canvas está rotado 90° CW por el padre.
        // rect.width  = ancho visual  = alto lógico del canvas (H_css)
        // rect.height = alto visual   = ancho lógico del canvas (W_css)
        // Transformación: cx = vy, cy = H_css - vx
        const vx = clientX - rect.left
        const vy = clientY - rect.top
        return {
          x: vy,
          y: rect.width - vx,
        }
      }

      return {
        x: clientX - rect.left,
        y: clientY - rect.top,
      }
    },

    startDrawing(e) {
      e.preventDefault()
      if (this.cargandoCreacionSolicitud) return

      const point = this.getPoint(e)

      this.isAlreadyDrawing = true
      this.isDrawing = true
      this.lastX = point.x
      this.lastY = point.y
    },

    draw(e) {
      e.preventDefault()
      if (!this.isDrawing || this.cargandoCreacionSolicitud) return

      const point = this.getPoint(e)
      const ctx = this.$refs.canvas.getContext('2d')

      ctx.beginPath()
      ctx.moveTo(this.lastX, this.lastY)
      ctx.lineTo(point.x, point.y)
      ctx.stroke()

      this.lastX = point.x
      this.lastY = point.y
    },

    stopDrawing(e) {
      if (e) e.preventDefault()
      this.isDrawing = false
    },

    clearCanvas() {
      this.isAlreadyDrawing = false

      const canvas = this.$refs.canvas
      const ctx = canvas.getContext('2d')
      const dpr = window.devicePixelRatio || 1

      ctx.setTransform(1, 0, 0, 1, 0, 0)
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
      this.setCanvasStyles(ctx)
    },
    esCanvasEnBlanco() {
      const canvas = this.$refs.canvas
      if (!canvas) return true
      const ctx = canvas.getContext('2d')
      const { data } = ctx.getImageData(0, 0, canvas.width, canvas.height)
      for (let i = 3; i < data.length; i += 4) {
        if (data[i] !== 0) return false
      }
      return true
    },

    async getSignatureImage() {
      this.isDrawing = false

      const canvas = this.$refs.canvas
      if (this.esCanvasEnBlanco()) {
        this.enviarAlertaError({
          mensaje:
            'La firma esta vacia. Por favor, vuelve a firmar dentro del recuadro.',
          tiempo: ALERTA_ERROR.tiempo,
          visibilidad: ALERTA_ERROR.visible,
        })
        return
      }

      const imageDataURL = canvas.toDataURL('image/png')
      const valor = imageDataURL.split(',')
      if (!valor[1]) {
        this.enviarAlertaError({
          mensaje:
            'No se pudo procesar la firma. Por favor, vuelve a firmar e intenta de nuevo.',
          tiempo: ALERTA_ERROR.tiempo,
          visibilidad: ALERTA_ERROR.visible,
        })
        return
      }

      let folioDigital = localStorage.getItem('FOLIO_DIGITAL')
      folioDigital = folioDigital.replace(/['"]+/g, '')

      const request = {
        folioDigital: folioDigital.toString(),
        base64Firma: valor[1],
      }

      this.cargandoCreacionSolicitud = true
      try {
        await this.GuardaFirmaAutografaDigital(request)
      } catch (error) {
        console.error(error)
        this.cargandoCreacionSolicitud = false
        this.enviarAlertaError({
          mensaje:
            'No se pudo guardar tu firma. Por favor, intenta firmar de nuevo.',
          tiempo: ALERTA_ERROR.tiempo,
          visibilidad: ALERTA_ERROR.visible,
        })
        return
      }

      if (this.$store.getters['credito/obtenerAplicaDevolucion'] == 1) {
        const idSolicitud = this.$store.getters['credito/obtenerIdSolicitud']
        this.actualizaEstatusSolicitud(idSolicitud)
      } else {
        this.crearSolicitud().then(() => {
          this.cargandoCreacionSolicitud = false
          this.$router.push('/terminacion')
        })
      }
    },

    async crearSolicitud() {
      let result
      const crearSolicitudRequest =
        this.$store.getters['credito/obtenerSolicitudDigitalRequest']

      try {
        if (this.$store.getters['credito/obtenerAplicaDevolucionMonto']) {
          result = await CreditoService.actualizaMontoSolicitudDigital(
            crearSolicitudRequest
          )
        } else {
          result = await CreditoService.insertarSolicitudDigital(
            crearSolicitudRequest
          )

          console.log(JSON.stringify(crearSolicitudRequest))
        }

        if (result.data.Codigo == 200 && result.data.Estado == true) {
          let resultadoActualizacionPersona
          this.$store.dispatch(
            'personaDocumentos/insertarComprobante',
            result.data.Modelo.Comprobante
          )

          const persona = this.$store.getters['persona/obtenerPersona']

          if (persona.tipoPersona == 2) {
            resultadoActualizacionPersona =
              await PersonaService.actualizarDomicilioProspecto(persona)

            if (
              resultadoActualizacionPersona.data.Codigo == 200 &&
              resultadoActualizacionPersona.data.Estado == true
            ) {
              this.$store.dispatch('credito/actualizarConfirmacion', false)
              this.$store.dispatch('credito/actualizarFinalizado', true)

              console.log('Llega aqui al final de todo')
              this.cargandoCreacionSolicitud = false
              this.$router.push('terminacion')
            } else {
              this.enviarAlertaError({
                mensaje:
                  'Ha ocurrido un error al procesar tu solicitud. Por favor, intente acceder de nuevo al link que recibió vía Whatsapp y reinicie el proceso.',
                tiempo: ALERTA_ERROR.tiempo,
                visibilidad: ALERTA_ERROR.visible,
              })
              this.cargandoCreacionSolicitud = false
            }
          } else {
            this.$store.dispatch('credito/actualizarConfirmacion', false)
            this.$store.dispatch('credito/actualizarFinalizado', true)
            this.$router.push('terminacion')
            this.cargandoCreacionSolicitud = false
          }
        } else {
          // TODO: re-habilitar cuando backend corrija el error de correo no registrado
          // this.enviarAlertaError({
          //   mensaje:
          //     result.data.Modelo?.Mensaje ||
          //     'Ha ocurrido un error al procesar tu solicitud. Por favor, intente acceder de nuevo al link que recibió vía Whatsapp y reinicie el proceso.',
          //   tiempo: ALERTA_ERROR.tiempo,
          //   visibilidad: ALERTA_ERROR.visible,
          // })
          console.error(result.data.Modelo?.Mensaje || result.data.Mensaje)
          this.cargandoCreacionSolicitud = false
        }
      } catch (error) {
        console.error(error)
        this.cargandoCreacionSolicitud = false
      }
    },

    ...mapActions({
      enviarAlertaError: 'alerta/enviarAlertaError',
      enviarAlertaExito: 'alerta/enviarAlertaExito',
      actualizaOTP: 'credito/actualizaOtpFirma',
      setEsOtpFirmaValido: 'credito/setEsOtpFirmaValido',
      setAceptaFirmar: 'credito/setAceptaFirmar',
      setSonTerminosBuroConfirmados: 'credito/setSonTerminosBuroConfirmados',
    }),
  },
}
</script>

<style scoped>
/* ── Desktop ──────────────────────────────────────────── */
.desktop-content {
  padding: 10px;
}

.firma-titulo {
  margin: 10px;
}

.signature-pad {
  width: 90%;
  max-width: 700px;
  margin: 0 auto;
}

.signature-pad-canvas {
  display: block;
  width: 100%;
  height: 320px;
  border: 1px solid #000;
  background: #fff;
  touch-action: none;
  box-sizing: border-box;
}

.signature-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.observaciones-firma {
  width: 90%;
  max-width: 700px;
  margin: 16px auto 0;
}

.signature-pad-canvas--disabled {
  pointer-events: none;
  opacity: 0.95;
}

/* ── Móvil landscape (rotación CSS) ──────────────────── */
.landscape-content {
  position: fixed;
  width: 100vh;
  height: 100vw;
  top: calc((100vh - 100vw) / 2);
  left: calc((100vw - 100vh) / 2);
  transform: rotate(90deg);
  transform-origin: center center;
  background: #fff;
  z-index: 100;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 12px;
  box-sizing: border-box;
}

.landscape-content .firma-titulo {
  margin: 0 0 8px 0;
  font-size: 14px;
  text-align: center;
  flex-shrink: 0;
}

.landscape-content .signature-pad {
  width: 100%;
  max-width: none;
  margin: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.landscape-content .signature-pad-canvas {
  flex: 1;
  height: 0;
  min-height: 0;
}

.landscape-content .signature-actions {
  flex-shrink: 0;
  margin-top: 8px;
}

.landscape-content .observaciones-firma {
  width: 100%;
  max-width: none;
  margin: 8px 0 0;
  flex-shrink: 0;
}
</style>
